import React, { useCallback, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";

import Container from "@mui/material/Container";
import AnthologyBrowser from "./browse/AnthologyBrowser";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import RequireRoles from "../../auth/RequireRoles";
import { useSearch } from "../searchServices";
import { mergeDeepRight } from "ramda";
import AnthologyEdit from "./edit/AnthologyEdit";
import { creatorRoles } from "../../auth/authUtils";

const useStyles = makeStyles(theme => ({
  panel: {
    display: "flex",
    flexDirection: "column",
    height: "95%",
    padding: "0",
    border: "3px solid white",
    background: "white",
    borderRadius: "20px",
  },
}));

const initialSearchState = (initialState = {}) => {
  return mergeDeepRight(
    {
      appliedQuery: [],
      appliedFacets: [
        {
          name: "type",
          queryParam: "_type",
          terms: [
            {
              code: "ANTHOLOGY",
            },
          ],
        },
        {
          name: "status",
          queryParam: "status",
          terms: [{ code: "(-status:* AND *:*)" }, { code: "status:*" }],
        },
      ],
      orderBy: null,
      orderDirection: "asc",
      otherParams: [],
      appliedPublicationYearGroups: [],
      titleOnly: false,
      moduleOnly: false,
      page: 0,
      noFacets: true,
    },
    initialState,
  );
};

const AnthologyView = () => {
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const initialSearch = (location.state && location.state.search) || [];

  const [searchState, setSearchState] = useState(
    initialSearchState(initialSearch),
  );

  const searchResults = useSearch(searchState);

  const handleSave = useCallback(() => {
    searchResults.refetch();
    navigate(-1);
  }, [searchResults, navigate]);

  const handleCancel = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <Container
      id="anthology-view"
      maxWidth={false}
      classes={{ root: classes.panel }}
    >
      <Routes>
        <Route
          index
          element={
            <RequireRoles roles={["ROLE_ADMIN"]} showUnauthorized={false}>
              <AnthologyBrowser
                searchState={searchState}
                onSearchStateChange={state => setSearchState(state)}
                searchResults={searchResults}
                onSaveSuccess={handleSave}
              />
            </RequireRoles>
          }
        />
        <Route
          path=":id/*"
          element={
            <RequireRoles roles={creatorRoles} showUnauthorized={false}>
              <AnthologyEdit onCancel={handleCancel} />
            </RequireRoles>
          }
        />
      </Routes>
    </Container>
  );
};

export default AnthologyView;
